<div class="dialog-header">
  <div class="dialog-header-title">{{ 'game.dialog.leaveTable.title' | translate }}</div>
  <div class="dialog-content">
    <div class="app-game-dialog-leave-table-content">
      <ng-container *ngIf="!data.actionControls.showImBackButton">
        <button appButton
          *ngIf="!data.isTournament"
          [disabled]="!data.actionControls.showSitoutNextBBButton"
          class="success"
          (click)="onOption(leaveTableOption.SitoutNextBB)"
        >
          <span>{{ 'game.dialog.leaveTable.sitoutNextBB' | translate }}</span>
        </button>

        <button appButton
          [disabled]="!data.actionControls.showSitoutNextHandButton"
          class="success"
          (click)="onOption(leaveTableOption.SitoutNexthand)"
        >
          <span>{{ 'game.dialog.leaveTable.sitoutNextHand' | translate }}</span>
        </button>
      </ng-container>


      <button appButton class="success" (click)="onOption(leaveTableOption.LeaveSeat)">
        <span
          *ngIf="data.myPlayerSeat.playerCallTime?.canLeaveTable === false"
          class="success"
        >
          <img src="assets/img/icons/call-time-attention.svg" alt />
        </span>
        <span>{{ 'game.dialog.leaveTable.leaveSeat' | translate }}</span>
      </button>

      <button appButton class="success" (click)="onOption(leaveTableOption.LeaveTable)">
        <span
          *ngIf="data.myPlayerSeat.playerCallTime?.canLeaveTable === false"
          class="success"
        >
          <img src="assets/img/icons/call-time-attention.svg" />
        </span>
        <span>{{ 'game.dialog.leaveTable.leaveTable' | translate }}</span>
      </button>

      <button appButton (click)="onOption()">{{ 'component.dialog.button.cancel' | translate }}</button>
    </div>
  </div>
</div>
